import { Badge, Footnote, SectionCard } from '../../../components/ui';
import { formatCount, formatDate, maskPhoneDisplay } from '../../../lib/format';
import type { OptOutContact } from '../types';
import { OPTOUT_REASON_LABEL } from '../vocabulario';

/**
 * Opt-out da empresa: contagem inteira e uma amostra curta, mascarada.
 *
 * A lista completa nao cabe aqui de proposito: o valor desta secao e a
 * pessoa ver que a regra existe e quantos sao. Exportar e gerenciar a lista
 * inteira e trabalho para quando o backend tiver `contact_optouts`.
 */
export function NumerosBloqueados({ optOuts, total }: { readonly optOuts: readonly OptOutContact[]; readonly total: number }): JSX.Element {
  return (
    <SectionCard
      id="opt-out"
      icon="escudo"
      title="Números bloqueados (opt-out)"
      description="Quem respondeu SAIR, bloqueou o número ou foi bloqueado pela equipe. Nunca entram em envio nenhum."
      aside={
        <Badge tone={total > 0 ? 'critical' : 'neutral'} dot>
          {formatCount(total)} {total === 1 ? 'bloqueado' : 'bloqueados'}
        </Badge>
      }
    >
      {optOuts.length === 0 ? (
        <p className="text-sm text-ink-muted">Nenhum número bloqueado ainda.</p>
      ) : (
        <ul className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3" aria-label="Amostra de números bloqueados">
          {optOuts.map((o) => (
            <li key={o.id} className="flex items-center justify-between gap-3 rounded-lg border border-line px-3 py-2 text-sm">
              <div className="min-w-0">
                <p className="tabular-nums text-ink">{maskPhoneDisplay(o.phoneE164)}</p>
                <p className="text-xs text-ink-subtle">{OPTOUT_REASON_LABEL[o.reason]}</p>
              </div>
              <span className="shrink-0 text-xs text-ink-subtle">{formatDate(o.at)}</span>
            </li>
          ))}
        </ul>
      )}
      {total > optOuts.length ? (
        <div className="mt-3">
          <Footnote>
            Mostrando {formatCount(optOuts.length)} de {formatCount(total)}. A lista completa e a exportação chegam com o backend.
          </Footnote>
        </div>
      ) : null}
    </SectionCard>
  );
}
